import PropTypes from 'prop-types';
import Input from '../../ui/Input';
import Select from '../../ui/Select';

const FiltrosFila1 = ({
  searchContext, isTableNotLoading, name, lastname, dni, idUser,
  year, yearList, handleNameOnChange, handleLastNameOnChange,
  handleDNIOnChange, handleIDOnChange, handleYear,
}) => {
  const hasRestoredSearch = searchContext !== '' && searchContext.newSearch === false;

  const getErrorMessage = (field) => {
    if (field.error === 'length') return 'Mínimo 2 caracteres';
    if (field.error === 'format') {
      if (field === dni) return 'Formato DNI incorrecto';
      return 'No permitido';
    }
    return undefined;
  };

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '12px', marginBottom: '12px' }}>
      <Input label="Nombre" type="text" name="name" id="name" placeholder="Nombre"
        onChange={handleNameOnChange} onInput={handleNameOnChange}
        defaultValue={hasRestoredSearch ? name.data : ''} disabled={!isTableNotLoading}
        error={getErrorMessage(name)} />
      <Input label="Apellidos" type="text" name="lastname" id="lastname" placeholder="Apellidos"
        onChange={handleLastNameOnChange} onInput={handleLastNameOnChange}
        defaultValue={hasRestoredSearch ? lastname.data : ''} disabled={!isTableNotLoading}
        error={getErrorMessage(lastname)} />
      <Input label="DNI" type="text" name="dni" id="dni" placeholder="DNI"
        onChange={handleDNIOnChange} onInput={handleDNIOnChange}
        defaultValue={hasRestoredSearch ? dni.data : ''} disabled={!isTableNotLoading}
        error={getErrorMessage(dni)} />
      <Input label="ID" type="text" name="idUser" id="idUser" placeholder="ID"
        onChange={handleIDOnChange} onInput={handleIDOnChange}
        defaultValue={hasRestoredSearch ? idUser.data : ''} disabled={!isTableNotLoading} />
      <Select label="Año" name="año" id="año" onChange={handleYear}
        disabled={!isTableNotLoading} value={year}
        options={yearList && yearList.length > 0 ? yearList : []} />
    </div>
  );
};

FiltrosFila1.propTypes = {
  searchContext: PropTypes.object, isTableNotLoading: PropTypes.bool,
  name: PropTypes.object, lastname: PropTypes.object, dni: PropTypes.object,
  idUser: PropTypes.object, year: PropTypes.string, yearList: PropTypes.array,
  handleNameOnChange: PropTypes.func, handleLastNameOnChange: PropTypes.func,
  handleDNIOnChange: PropTypes.func, handleIDOnChange: PropTypes.func, handleYear: PropTypes.func,
};

export default FiltrosFila1;
